import React, { createContext, useContext, useState } from "react";
import { LOCAL_STORAGE_KEYS } from "../../constants/global.constants";
import { getLocalState } from "../../utils/local-storage-utils";

const initialContext = {
  property: null,
  setProperty: () => {},
  propertyLocation: null,
  setPropertyLocation: () => {},
};

const AppContext = createContext(initialContext);

const AppProvider = ({ children }) => {
  const showBaseBuildings_LS = getLocalState(LOCAL_STORAGE_KEYS.showBaseBuildings);

  const [property, setProperty] = useState(null);
  const [propertyLocation, setPropertyLocation] = useState(null);
  const [showBaseBuildings, setShowBaseBuildings] = useState(showBaseBuildings_LS);

  return (
    <AppContext.Provider
      value={{
        property,
        setProperty,
        propertyLocation,
        setPropertyLocation,
        showBaseBuildings, 
        setShowBaseBuildings
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  return useContext(AppContext);
};

export { AppProvider, useAppContext };
